import { BASE_ROUTES } from 'utils';
import axios from 'axios';
import jwtWorker from 'utils/jwt-worker';


const defaultAxiosInstance = axios.create();
defaultAxiosInstance.interceptors.request.use(
    async (config) => {
        config.baseURL = process.env.REACT_APP_API_URL;
        config.timeout = 60000;
        config.headers.Authorization = jwtWorker.getTokenFromStorage();
        return config;
    },
    error => Promise.reject(error)
);

export class ServiceRestApi {

    axiosInstance;
    constructor(instance) { this.axiosInstance = instance ? instance : defaultAxiosInstance; }
    /************************ CUSTOM HTTP CALLS ***************************/

    get = (suffix) => new Promise((resolve, reject) => {
        this.axiosInstance.get(suffix).then(response => {
            response.data.code === 0 ? resolve(response.data) : reject(response.data.message);
        }, error => {
            reject(this.handleResponseError(error, suffix));
        })
    });

    post = (suffix, payload) => new Promise((resolve, reject) => {
        this.axiosInstance.post(suffix, payload).then(response => {
            response.data.code === 0 ? resolve(response.data) : reject(response.data.message);
        }, error => {
            reject(this.handleResponseError(error, suffix, payload));
        })
    });

    patch = (suffix, payload) => new Promise((resolve, reject) => {
        this.axiosInstance.patch(suffix, payload).then(response => {
            response.data.code === 0 ? resolve(response.data) : reject(response.data.message);
        }, error => {
            reject(this.handleResponseError(error, suffix));
        })
    });

    delete = (suffix, payload) => new Promise((resolve, reject) => {
        this.axiosInstance.delete(suffix, payload).then(response => {
            response.data.code === 0 ? resolve(response.data) : reject(response.data.message);
        }, error => {
            reject(this.handleResponseError(error, suffix));
        })
    });

    handleResponseError = (error, suffix, payload) => {
        this.customInterceptor(suffix, error.response?.data.code, payload, error.response?.data);
        return error.response ? (
            error.response?.data.message ? `${error.response.data.message}` : error.message) :
            error.message;
    }

    customInterceptor = (suffix, code, payload, dataResponse) => {

        if (suffix?.includes("api") && code === 401) {
            Promise.resolve(jwtWorker.deleteItemFromStorage(jwtWorker.TOKEN_META_KEY)).then(() => {
                window.location.reload(false);
            });
        }

        //Handle first authentication for change password redirect
        if (suffix?.includes(BASE_ROUTES.LOGIN) && code === 1) {
            window.history.pushState({}, {}, `${process.env.PUBLIC_URL}${BASE_ROUTES.PASSWORD_FIRST_LOGIN}?username=${payload.username}&uuid=${dataResponse.result}`);
            window.location.reload();
        }

        //Handle uuid expiration for first change password
        if (suffix?.includes("/password") && code === -1) {
            window.history.pushState({}, {}, `${process.env.PUBLIC_URL}${BASE_ROUTES.LOGIN}`);
            window.location.reload();
        }

    }

}

export default new ServiceRestApi();